import { render } from "./TarjetaInfoEstadoProyecto.vue?vue&type=template&id=5c8e7a45&scoped=true"
import script from "./TarjetaInfoEstadoProyecto.vue?vue&type=script&lang=js"
export * from "./TarjetaInfoEstadoProyecto.vue?vue&type=script&lang=js"

import "./TarjetaInfoEstadoProyecto.vue?vue&type=style&index=0&id=5c8e7a45&scoped=true&lang=scss"

import exportComponent from "/home/cubel/PhpstormProjects/failder/vue-failder/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c8e7a45"]])

export default __exports__